export default {
    namespaced : true,
    state : {
    },    
    actions : {

        getAddressDetails : (rootState, payload) => {
            
            var result = {}
            
            if ( rootState.rootState.temp_address.straatnaam !== undefined && rootState.rootState.temp_address.huis_nlt !== undefined) {
                result.address = rootState.rootState.temp_address.straatnaam + " " + rootState.rootState.temp_address.huis_nlt;
            }      

            if (rootState.rootState.temp_address.postcode !== undefined) {
                result.postal_code = rootState.rootState.temp_address.postcode;
            }

            if (rootState.rootState.temp_address.woonplaatsnaam !== undefined) {
                result.city = rootState.rootState.temp_address.woonplaatsnaam;
            }
            if (rootState.rootState.temp_address.id !== undefined) {
                result.adr_id = rootState.rootState.temp_address.id;
            }

            if (payload.vastgoed == true) {
                result.woonplaatscode = rootState.rootState.temp_address.woonplaatscode;
                result.county = rootState.rootState.temp_address.provincienaam;
                result.provinciecode = rootState.rootState.temp_address.provinciecode;
                
                if (rootState.rootState.temp_address.gekoppeld_perceel !== undefined) {
                    result.perceel = rootState.rootState.temp_address.gekoppeld_perceel[0];
                }
                
                result.country = "Nederland";
                result.wijkcode = rootState.rootState.temp_address.wijkcode;
                result.buurtcode = rootState.rootState.temp_address.buurtcode;
                result.wijknaam = rootState.rootState.temp_address.wijknaam;
                result.buurtnaam = rootState.rootState.temp_address.buurtnaam;
            }

            return result
        }
   
    }
}